<template>
  <div
    class="meta-bar col-12-bottom"
    :class="barSizeClass"
  >
    <div class="meta-bar__row row-noBottom">
      <div
        v-if="cookingTimeText"
        :aria-label="cookingTime + ' att tillaga'"
        class="col meta-bar__time"
      >
        <span aria-hidden="true">
          <svgicon
            class="meta-bar__icon"
            name="Time/Time"
          />
          {{ cookingTimeText }}
        </span>
      </div>
      <div
        v-if="showIngredientsText"
        :aria-label="numberOfIngredients + ' ingredienser'"
        class="col"
      >
        <span aria-hidden="true">
          <svgicon
            class="meta-bar__icon"
            name="Cooking/Groceries"
          />
          {{ numberOfIngredients }}
          <span>Ingredienser</span>
        </span>
      </div>
      <div
        v-if="showDifficultyText && cookingLevelIcon[difficulty]"
        :aria-label="difficulty + ' svårighetsgrad'"
        class="col"
      >
        <span aria-hidden="true">
          <svgicon
            class="meta-bar__icon"
            :name="cookingLevelIcon[difficulty]"
          />
          <span>{{ difficulty }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import svgicon from 'vue-svgicon'
import '#/Cooking/Level1'
import '#/Cooking/Level2'
import '#/Cooking/Level3'
import '#/Cooking/Groceries'
import '#/Time/Time'

export default {
  name: 'RecipeCardMeta',
  components: {
    svgicon,
  },
  props: {
    blockSize: {
      type: String,
      default: 'quarter',
      validator (value) {
        return ['full', 'half', 'third', 'quarter'].includes(value)
      },
    },
    cookingTime: {
      type: String,
      required: true,
    },
    numberOfIngredients: {
      type: Number,
      required: true,
    },
    difficulty: {
      type: String,
      required: true,
    },
    insideModal: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isMounted: false,
      cookingLevelIcon: {
        Enkel: 'Cooking/Level1',
        Medel: 'Cooking/Level2',
        Avancerad: 'Cooking/Level3',
      },
    }
  },
  computed: {
    barSizeClass () {
      switch (this.$root.currentSize) {
        case 'lg':
        case 'xl':
          return this.isBlockSize.full || this.isBlockSize.half ? 'medium-bar' : 'small-bar'
        default:
          return 'small-bar'
      }
    },
    isBlockSize () {
      return {
        [this.blockSize]: true,
      }
    },
    cookingTimeText () {
      return this.cookingTime?.split('minuter').join('min') || ''
    },
    showIngredientsText () {
      if (this.numberOfIngredients) {
        if (!this.cookingTimeText && !this.showDifficultyText) {
          return true
        }
        if (!this.isMounted || (this.widthBetween(0, 768) && !this.isBlockSize.full)) {
          return false
        } else if (this.$root.currentSizeGte('sm')) {
          switch (this.blockSize) {
            case 'full':
              return true
            case 'half':
              return this.widthOver(400)
            case 'third':
              return this.widthOver(1150)
            case 'quarter':
              return false
          }
        }
      }
      return false
    },
    showDifficultyText () {
      if (!this.isMounted || !this.difficulty) {
        return false
      } else if (!this.cookingTimeText) {
        return true
      }

      if (this.widthBetween(500, 768) || this.isBlockSize.full) {
        return true
      } else if (this.$root.currentSizeGte('sm')) {
        switch (this.blockSize) {
          case 'full':
          case 'half':
            return true
          case 'third':
            return this.$root.currentSizeGte('lg') && !this.insideModal
          case 'quarter':
            return this.$root.currentSizeGte('xl') && !this.insideModal
        }
      }
      return false
    },
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    widthBetween (a, b) {
      return this.$root.windowWidth >= a && this.$root.windowWidth < b
    },
    widthOver (a) {
      return this.$root.windowWidth >= a
    },
  },
}
</script>

<style lang="scss">
.meta-bar {
  $base: &;

  padding: 0 0.5rem 0.5rem 0.5rem !important; // to override .col style

  @include font(text, 1, bold);

  color: $color-green-dark;
  text-align: center;
  width: 100%;

  // .small-bar is default
  line-height: 2rem;
  font-size: 0.75rem;

  &__icon {
    height: 1rem;
    width: 1rem;
    fill: $color-green-dark;
    top: -1px;
    margin-right: 2px;
    position: relative;
  }

  &.medium-bar {
    line-height: 3rem;
    font-size: 0.875rem;

    .meta-bar__icon {
      height: 1.25rem;
      width: 1.25rem;
    }
  }

  &.large-bar {
    line-height: 5rem;
    font-size: 1rem;

    .meta-bar__icon {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  &__row {
    &.row-noBottom {
      margin-left: 0;
      margin-right: 0;
    }

    .col {
      flex: 0 0 0%;
      padding-left: 0.375rem;
      padding-right: 0.375rem;
      white-space: nowrap;
    }

    border-radius: 4px;
    background: $color-green-lightest;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }
}
</style>
